import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getWebStoryTemplates } from "./actions.js";

export const webStoryTemplatesEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = webStoryTemplatesEntityAdapter.getInitialState({
  ids: [],
  storyCount: 0,
});

export const webStoryTemplatesSlice = createSlice({
  name: "webStoryTemplates",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getWebStoryTemplates.fulfilled, (state, action) => {
      if (action.payload.status) {
        webStoryTemplatesEntityAdapter.setAll(state, action.payload.data);
        state.storyCount = action.payload.storyCount;
      } else {
        state.ids = [];
        state.storyCount = 0;
      }
    });
  },
});

export default webStoryTemplatesSlice.reducer;
